import Pagination from "../../entities/Pagination";
import {action, computed, makeObservable, observable, runInAction} from "mobx";
import {PromotionService} from "../../service/PromotionService";
import CommonStore from "../../stores/CommonStore";
import Promotion from "../../entities/Promotion";

class PromotionStore {

    public promotions: Promotion[];
    public pagination: Pagination;
    public filter?: string;
    public commonStore: CommonStore;


    constructor(commonStore: CommonStore) {
        this.pagination = new Pagination(1, 15, 0, 0);
        this.promotions = [];
        this.commonStore = commonStore;
        makeObservable(this, {
            promotions: observable,
            pagination: observable,
            isEmpty: computed
        });
    }

    get isEmpty(): boolean {
        return this.promotions.length === 0;
    }

    public setFilter(filer: string) {
        this.filter = filer;
    }

    @action
    public async search() {
        await this.getElements(1);
    }


    @action
    public async goToPage(page: number = this.pagination.currentPage, pageSize: number = this.pagination.pageSize): Promise<void> {
        await this.getElements(page, pageSize);
    }

    @action
    public async getElements(page: number = this.pagination.currentPage, pageSize: number = this.pagination.pageSize): Promise<void> {
        this.commonStore.setLoading();
        const response = await PromotionService.get(page, pageSize, this.filter);
        if (response.success) {
            runInAction(() => {
                this.promotions = response.data?.data || [];
                this.pagination = response.data?.pagination || this.pagination;
            })
        }
        this.commonStore.processErrors(response);
        this.commonStore.removeLoading();
    }

}

export default PromotionStore;